module.exports = __webpack_public_path__ + "img/kbckzxt.a625c606.jpg";